import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import axios from 'axios'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(ElementUI)
Vue.config.productionTip = false

// axios 简单挂载
axios.defaults.baseURL = process.env.VUE_APP_API_BASE || ''
Vue.prototype.$http = axios

// 简单请求进度条（你也可以放到拦截器里）
axios.interceptors.request.use(cfg => {
  NProgress.start()
  return cfg
})
axios.interceptors.response.use(
  res => { NProgress.done(); return res },
  err => { NProgress.done(); return Promise.reject(err) }
)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')